// extracted by mini-css-extract-plugin
export default {"heading":"Qs-z","corrected":"Rs-z","redirectVerbiageContainer":"Ss-z","redirectVerbiageText":"Ts-z"};